import React from 'react';
import Menu from './components/Menu/Menu';
import Homepage from './components/Homepage/Homepage';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className="App">
      <Menu />
      <Homepage />
      <Footer />
    </div>
  );
}

export default App;
